import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated'

import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'
import { colors } from '@ui/colors'

type Props = {
  progress: number
}

const checkCompleted = (progress: number) => (progress === 1 ? 1 : 0)

export default function MeasurementProgress({ progress }: Props) {
  const animatedProgress = useSharedValue(progress)
  const animatedCompleted = useSharedValue(checkCompleted(progress))

  const styleProgress = useAnimatedStyle(() => ({
    width: `${animatedProgress.value * 100}%`,
    backgroundColor: interpolateColor(
      animatedCompleted.value,
      [0, 1],
      [colors.white, colors.green[400]]
    ),
  }))

  const styleOuter = useAnimatedOpacity(progress !== 0)

  useEffect(() => {
    animatedProgress.set(
      withTiming(progress, {
        duration: 1000,
        easing: Easing.bezier(0.25, 0.1, 0.25, 1.0),
      })
    )

    const isCompleted = checkCompleted(progress)

    animatedCompleted.set(
      withDelay(
        isCompleted ? 600 : 0,
        withTiming(isCompleted, {
          duration: 300,
          easing: Easing.out(Easing.ease),
        })
      )
    )
  }, [progress, animatedProgress, animatedCompleted])

  return (
    <Animated.View
      className="absolute left-0 right-0 top-0 flex w-full items-center justify-center"
      style={styleOuter}
    >
      <View
        className="relative inset-0 flex w-full flex-row items-start justify-start overflow-hidden rounded-full bg-white/10"
        style={{ height: 8, width: 320 }}
      >
        <Animated.View
          className="h-full rounded-full bg-white"
          style={styleProgress}
        />
      </View>
    </Animated.View>
  )
}
